import { usePersistedState } from "@justhome/common/hooks";
import { Button, Modal } from "@justhome/react-ui";
import { useRouter } from "next/router";
import { FC, useEffect, useRef, useState } from "react";

export interface LanguageModalProps {}

const LanguageModal: FC<LanguageModalProps> = () => {
  const router = useRouter();
  const { pathname, asPath, query } = router;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [languageModalDone, setLanguageModalDone] = usePersistedState(
    "languageModalDone",
    false,
  );
  const hasShownModal = useRef(false);

  useEffect(() => {
    if (languageModalDone || hasShownModal.current) {
      return;
    }

    setIsModalOpen(
      !navigator.language.startsWith("de") && router.locale != "en",
    );
    hasShownModal.current = true;
  }, [languageModalDone, router]);

  function handleModalClose() {
    setLanguageModalDone(true);
    setIsModalOpen(false);
  }

  function handleChangeLanguage() {
    handleModalClose();
    setLanguageModalDone(true);
    router.replace({ pathname, query }, asPath, { locale: "en" });
  }

  return (
    <Modal isOpen={isModalOpen} setIsOpen={setIsModalOpen}>
      <span>
        We have noticed that your browser language is not German.
        <br />
        Would you like to switch to the English version of the page?
      </span>
      <div className="flex flex-col gap-y-2s items-center mt-m">
        <Button variant="primary" size="md" onClick={handleChangeLanguage}>
          Go to English version
        </Button>
        <Button variant="ghost" size="md" onClick={handleModalClose}>
          Stay with German version
        </Button>
      </div>
    </Modal>
  );
};

export default LanguageModal;
